'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import type { TopNavV6MiniMenu, TopNavV6MiniMenuItem } from '@src/components/TopNavV6/TopNavV6Props';
import { cn } from '@src/utils/tailwind';
interface TopNavV6DesktopMiniMenuProps {
  menu: TopNavV6MiniMenu;
  isVisible: boolean;
  onMouseLeave?: () => void;
}
const MiniMenuItem = t0 => {
  const $ = _c(17);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.title) {
    t1 = <span className="font-sans text-body-sm leading-5 text-bodi-gray-butters transition-colors group-hover:text-bodi-white group-hover:underline group-hover:decoration-bodi-white">{item.title}</span>;
    $[0] = item.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== item.badge) {
    t2 = item.badge && <div className="flex items-center gap-1 text-body-sm leading-5"><span className="font-sans font-normal text-bodi-gray-butters">-</span><span className="text-center font-sans font-medium text-bodi-accent-bright-500">{item.badge}</span></div>;
    $[2] = item.badge;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center gap-1 whitespace-nowrap">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const content = t3;
  if (item.href) {
    let t4;
    if ($[7] !== content || $[8] !== item.href || $[9] !== item.onClick) {
      t4 = <LocalizedLink href={item.href} onClick={item.onClick} className="group flex items-center rounded-md transition-colors">{content}</LocalizedLink>;
      $[7] = content;
      $[8] = item.href;
      $[9] = item.onClick;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t4;
  if ($[11] !== item) {
    t4 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        item.onClick?.();
      }
    };
    $[11] = item;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== content || $[14] !== item.onClick || $[15] !== t4) {
    t5 = <div className="group flex items-center rounded-md transition-colors" onClick={item.onClick} onKeyDown={t4} role="button" tabIndex={0}>{content}</div>;
    $[13] = content;
    $[14] = item.onClick;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export const TopNavV6DesktopMiniMenu = t0 => {
  const $ = _c(15);
  const {
    menu,
    isVisible,
    onMouseLeave
  } = t0;
  const [shouldShow, setShouldShow] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isVisible) {
    t1 = () => {
      if (isVisible) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setShouldShow(true);
          });
        });
      } else {
        setShouldShow(false);
      }
    };
    t2 = [isVisible];
    $[0] = isVisible;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = !shouldShow;
  let t4;
  if ($[3] !== shouldShow || $[4] !== t3) {
    t4 = cn("absolute top-full left-0 z-30 -mt-1 w-auto min-w-[200px] border-b border-bodi-gray-dark bg-bodi-black-text py-4 transition-opacity duration-300 ease-in-out", {
      "opacity-0 invisible pointer-events-none": t3,
      "opacity-100 visible": shouldShow
    });
    $[3] = shouldShow;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      backgroundImage: "linear-gradient(90deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%), linear-gradient(90deg, rgba(22, 24, 25, 1) 0%, rgba(22, 24, 25, 1) 100%)"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== menu.items) {
    t6 = menu.items.filter(_temp).map(_temp2);
    $[7] = menu.items;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <div className="px-4"><div className="flex flex-col gap-1">{t6}</div></div>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onMouseLeave || $[12] !== t4 || $[13] !== t7) {
    t8 = <div onMouseLeave={onMouseLeave} className={t4} style={t5}>{t7}</div>;
    $[11] = onMouseLeave;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function _temp(item) {
  return item.hiddenOn !== "desktop";
}
function _temp2(item_0, itemIndex) {
  return <MiniMenuItem key={`mini-menu-item-${itemIndex}`} item={item_0} />;
}